import Vue from "vue"
import Vuex from "vuex"
import stage from "./modules/stage/index"
import appStage from "./modules/appStage/index"
import bigScreen from "./modules/bigScreen/index"
import menu from "./modules/menu/index"
import bigScreenMenu from "./modules/bigScreenMenu/index"
import appMenu from "./modules/appMenu/index"
import operation from "./modules/operation/index"
import states from "./modules/states/index"
import swiperState from "./modules/swiperState/index"
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    stage: stage,
    appStage: appStage,
    bigScreen: bigScreen,
    menu: menu,
    bigScreenMenu: bigScreenMenu,
    appMenu: appMenu,
    states: states,
    swiperState: swiperState,
    operation: operation
  }
})

if (module.hot) {
  // 使 所有模块 成为可热重载模块
  module.hot.accept(
    [
      "./modules/stage/index",
      "./modules/appStage/index",
      "./modules/bigScreen/index",
      "./modules/menu/index",
      "./modules/bigScreenMenu/index",
      "./modules/appMenu/index",
      "./modules/swiperState/index",
      "./modules/operation/index",
      "./modules/states/index"
    ],
    () => {
      // 获取更新后的模块
      // 因为 babel 6 的模块编译格式问题，这里需要加上 `.default`
      const stage = require("./modules/stage/index").default
      const appStage = require("./modules/appStage/index").default
      const bigScreen = require("./modules/bigScreen/index").default
      const menu = require("./modules/menu/index").default
      const bigScreenMenu = require("./modules/bigScreenMenu/index").default
      const appMenu = require("./modules/appMenu/index").default
      const swiperState = require("./modules/swiperState/index").default
      const operation = require("./modules/operation/index").default
      const states = require("./modules/states/index").default
      // 加载新模块
      store.hotUpdate({
        modules: {
          stage: stage,
          appStage: appStage,
          bigScreen: bigScreen,
          menu: menu,
          bigScreenMenu: bigScreenMenu,
          appMenu: appMenu,
          states: states,
          swiperState: swiperState,
          operation: operation
        }
      })
    }
  )
}
if (window.location.href.includes("appHome") || window.location.href.includes("ssrPreview")) {
  store.dispatch("operation/setActive", { id: 1 })
} else store.dispatch("operation/setActive", { id: 0 })
export default store
